import "../../../../content/departments/media/smm.css";
import * as React from 'react';
export default {
  React
};